import { Page } from "shared/react";
import { MEMBERS_MAX } from "shared/schema";
import { USER } from "../util/user.js";
import { MemberGroupList } from "./GroupList.js";
import { GroupsNavigation } from "./GroupsNavigation.js";

export function InvitesPage(): React.ReactElement {
	return (
		<Page title="Group invites">
			<GroupsNavigation>
				<h1>Group invites</h1>
			</GroupsNavigation>
			<section>
				<MemberGroupList //
					query={{ uid: USER.data.uid, status: "invited", $order: "!updated", $limit: MEMBERS_MAX }}
					more="Show more invites"
					empty="No invites"
				/>
			</section>
		</Page>
	);
}
